// extracted by mini-css-extract-plugin
module.exports = {"awardList":"_1I4Vup"};